import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, CanActivate } from '@angular/router';
import { MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { WithOnDestroy } from '@schenck/rotec-components';
import { Observable } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard extends WithOnDestroy implements CanActivate {
  private readonly authService = inject(MsalService);
  private readonly msalBroadcastService = inject(MsalBroadcastService);
  private readonly router = inject(Router);

  constructor() {
    super();
  }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    this.authService.handleRedirectObservable().pipe(takeUntil(this.onDestroy$)).subscribe();
    return this.msalBroadcastService.inProgress$.pipe(
      filter((status: InteractionStatus) => status === InteractionStatus.None),
      takeUntil(this.onDestroy$),
      map(() => {
        const isAuth = !!this.authService.instance.getAllAccounts()[0];
        if (!isAuth) {
          this.router.navigate(['/login']);
        }
        return isAuth;
      })
    );
  }
}
